export default "__VITE_ASSET__CGAcs7P3__"